module.exports = __webpack_public_path__ + "img/accessory_shoe_08.05d49252.svg";